var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99987 13.6666C10.6406 13.6666 13.6667 10.647 13.6667 6.99992C13.6667 3.35927 10.6339 0.333252 6.99318 0.333252C3.34632 0.333252 0.333344 3.35927 0.333344 6.99992C0.333344 10.647 3.35273 13.6666 6.99987 13.6666ZM7.00015 12.5556C3.91467 12.5556 1.45024 10.0848 1.45024 6.99992C1.45024 3.92119 3.90797 1.44427 6.99318 1.44427C10.0717 1.44427 12.5487 3.92147 12.5554 6.99992C12.5618 10.0851 10.0781 12.5556 6.99959 12.5556M6.99318 8.18289C7.30664 8.18289 7.48316 8.00636 7.48958 7.6667L7.58774 4.21568C7.59444 3.88215 7.33285 3.63396 6.98649 3.63396C6.63343 3.63396 6.38523 3.87574 6.39164 4.20899L6.4767 7.6667C6.48312 7.99995 6.66634 8.18289 6.99318 8.18289ZM6.99318 10.307C7.36548 10.307 7.69873 10.0064 7.69873 9.62743C7.69873 9.24176 7.37217 8.94755 6.99318 8.94755C6.60749 8.94755 6.28707 9.24817 6.28707 9.62743C6.28707 10 6.61391 10.307 6.99318 10.307Z",
    fill: "#B1B1B1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.feea3881dd16ac620aa64afc26c61486.svg";
export { ForwardRef as ReactComponent };